import { render, staticRenderFns } from "./ChatChatChatting.vue?vue&type=template&id=2129c9bf&"
import script from "./ChatChatChatting.vue?vue&type=script&lang=js&"
export * from "./ChatChatChatting.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatChatting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports